import React from 'react';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import {
  accordionStateOptions,
  AccordionStateType,
  IMarketplaceFilterTagAllValues,
  IMarketplaceProperty,
  sortOrderOptions,
  sortOrderOptionsMap,
  sortOrderOptionsNotProjectName,
  SortOrderType,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { InfoTag } from 'src/components/profileComponents/Marketplace/components/Filters/components/InfoTag';
import {
  useStyles,
} from './styles';

interface ITag {
  item: IMarketplaceFilterTagAllValues,
  lang: string
  propertyOptions: IDevelopmentSpecificationPropChange<IMarketplaceProperty>[]
  onTrash: () => void,
  onChange: (item: IMarketplaceFilterTagAllValues) => void,
}

export const TagAllValues: React.FC<ITag> = ({
  item, lang, propertyOptions, onTrash, onChange,
}) => {
  const styles = useStyles();
  const isProjectName = item.property?.systemName === 'projectName';
  return (
    <>
      <GroupWrapper
        name="Tag(all values)"
        startIcon={<LabelOutlinedIcon />}
        actions={(
          <GroupWrapperFiltersAction
            onTrash={onTrash}
            onDrag={() => {}}
          />
        )}
      >
        <div className={styles.tagWrapper}>
          <BoxFormTextField
            label={translations.name}
            name="name"
            defaultValue={item.name?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'name', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.callToAction}
            name="callToAction"
            defaultValue={item.callToActionText?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'callToActionText', lang, event.target.value));
            }}
          />
          <BoxFormAutocomplete
            label={translations.chooseProperty}
            name="property"
            defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
            onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
              onChange({ ...item, property: event.value });
            }}
            options={propertyOptions}
          />
          <BoxFormAutocomplete
            label={translations.sortOrder}
            name="sortOrder"
            defaultValue={
              item.propertyValuesOrder
                ? {
                  label: sortOrderOptionsMap[item.propertyValuesOrder],
                  value: item.propertyValuesOrder,
                }
                : undefined
            }
            options={isProjectName ? sortOrderOptions : sortOrderOptionsNotProjectName}
            onChange={(event: IDevelopmentSpecificationPropChange<SortOrderType>) => {
              onChange({ ...item, propertyValuesOrder: event.value });
            }}
          />
          <BoxFormAutocomplete
            label={translations.accordionState}
            name="accordionState"
            defaultValue={{ label: item.accordionState, value: item.accordionState }}
            options={accordionStateOptions}
            onChange={(event: {label: string, value: AccordionStateType}) => {
              onChange({ ...item, accordionState: event.value });
            }}
          />
        </div>
        <InfoTag
          item={item.tooltip}
          lang={lang}
          onChange={(tooltip) => onChange({ ...item, tooltip })}
        />
      </GroupWrapper>
    </>
  );
};
